import { SelectProps } from '@radix-ui/react-select'
import { Checkbox } from '../../components/ui/checkbox'
import { Input, InputProps } from '../../components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select'
import { Textarea } from '../../components/ui/textarea'
import React, { JSX, RefAttributes } from 'react'
import { Form } from '@telesoft/types/payload-types'
import { FormControl } from '../ui/form'
import { ControllerRenderProps } from 'react-hook-form'

type FieldsArray = NonNullable<Form['fields']>
type SelectBlockType = Extract<FieldsArray[number], { blockType: 'select' }>

export const fields = {
  text: Input,
  textarea: Textarea,
  select: (
    props: SelectBlockType &
      ControllerRenderProps<
        {
          [x: string]: any
        },
        string
      >,
  ) => {
    const { options } = props
    return (
      <Select onValueChange={props.onChange} defaultValue={props.value}>
        <FormControl>
          <SelectTrigger className="">
            <SelectValue placeholder="Select..." defaultValue={props.value} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {options?.map((option, i) => {
            return (
              <SelectItem key={i} value={option.value}>
                {option.label}
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select>
    )
  },
  checkbox: Checkbox,
  email: (props: JSX.IntrinsicAttributes & InputProps & RefAttributes<HTMLInputElement>) => {
    return <Input type="email" {...props} />
  },
  state: (props: JSX.IntrinsicAttributes & SelectProps) => {
    return <Select {...props} />
  },
  message: (props: { message: any }) => {
    return <div>{JSON.stringify(props)}</div>
  },
  number: Number,
  country: Input,
}
